import { twMerge } from 'tailwind-merge';

import { Image } from '../../types/Image';
import { Video } from '../../types/Video';
import { PostMediaWrapper } from './PostMediaWrapper/PostMediaWrapper';
import { GearButton } from './GearButton/GearButton';
import { PostImagePlaceholder } from '../PostImagePlaceholder/PostImagePlaceholder';

interface PostMediaSectionProps {
  className?: string;
  usedGearsCount: number | undefined;
  userNickname: string | undefined;
  images: Image[];
  video?: Video;
  onGearButtonClick: () => void;
  isTouchDevice?: boolean;
  hasCatch?: boolean;
}

export const PostMediaSection = ({
  className,
  usedGearsCount,
  userNickname,
  images,
  video,
  onGearButtonClick: handleGearButtonClick,
  isTouchDevice = false,
  hasCatch = false,
}: PostMediaSectionProps) => {
  const shouldShowCatchMedia = !!images.length || !!video;
  const gearButtonContent = 'Tap to see gear used';

  return (
    <div
      className={twMerge(
        `relative size-full bg-black ${isTouchDevice ? '' : 'flex flex-row rounded-l-lg'}`,
        className,
      )}
    >
      {!shouldShowCatchMedia && <PostImagePlaceholder />}
      {shouldShowCatchMedia && (
        <PostMediaWrapper
          images={images}
          video={video}
          userNickname={userNickname}
          isTouchDevice={isTouchDevice}
        />
      )}
      {hasCatch && !!usedGearsCount && (
        <GearButton
          className={`absolute left-4 ${isTouchDevice ? 'bottom-9' : 'bottom-4'}`}
          onClick={handleGearButtonClick}
        >
          {gearButtonContent}
        </GearButton>
      )}
    </div>
  );
};
